import Dimmer from 'semantic-ui-react/dist/commonjs/modules/Dimmer';
import '@purple/semantic-ui-purple-theme/components/dimmer.css';

export default Dimmer;
